import T from '../../../../../common/components/T';

export const getCategoriesAll = () => [
    {
        name: 'searchTab',
        icon: 'search-thin',
        title: <T textName='iconsModal-text-7' defaultStr='Поиск иконок' page='/admin/menu' />
    },
    {
        name: 'blockTab',
        icon: 'table-alt',
        title: <T textName='iconsModal-text-4' defaultStr='Системная библиотека' page='/admin/menu' />
    }
];

export const getCategoriesMobile = () => [
    {
        name: 'blockTab',
        icon: 'table-alt',
        title: <T textName='iconsModal-text-4' defaultStr='Системная библиотека' page='/admin/menu' />
    }
];

export const icons = [
    {
        name: 'menu-home',
        tags: [],
        size: 'normal',
        title: 'home'
    },
    {
        name: 'menu-admin',
        tags: [],
        size: 'normal',
        title: 'admin'
    },
    {
        name: 'menu-battery-full',
        tags: [],
        size: 'normal',
        title: 'battery-full'
    },

    {
        name: 'menu-battery-low',
        tags: [],
        size: 'normal',
        title: 'battery-low'
    },

    {
        name: 'menu-battery-mid',
        tags: [],
        size: 'normal',
        title: 'battery-mid'
    },

    {
        name: 'menu-battery-v',
        tags: [],
        size: 'normal',
        title: 'battery-v'
    },

    {
        name: 'menu-store',
        tags: [],
        size: 'normal',
        title: 'store'
    },
    {
        name: 'menu-users',
        tags: [],
        size: 'normal',
        title: 'users'
    },
    {
        name: 'menu-settings',
        tags: [],
        size: 'normal',
        title: 'settings'
    },
    {
        name: 'menu-wallets',
        tags: [],
        size: 'normal',
        title: 'wallets'
    },
    {
        name: 'menu-report',
        tags: [],
        size: 'normal',
        title: 'report'
    },
    {
        name: 'menu-site-filling',
        tags: [],
        size: 'normal',
        title: 'site-filling'
    },
    {
        name: 'menu-file',
        tags: [],
        size: 'normal',
        title: 'file'
    },
    {
        name: 'menu-category',
        tags: [],
        size: 'normal',
        title: 'category'
    },
    {
        name: 'menu-form-managment',
        tags: [],
        size: 'normal',
        title: 'form-managment'
    },
    {
        name: 'menu-security',
        tags: [],
        size: 'normal',
        title: 'security'
    },
    {
        name: 'menu-tron',
        tags: [],
        size: 'normal',
        title: 'tron'
    },
    {
        name: 'menu-communication',
        tags: [],
        size: 'normal',
        title: 'communication'
    },
    {
        name: 'menu-faq',
        tags: [],
        size: 'normal',
        title: 'faq'
    },
    {
        name: 'menu-bar-code',
        tags: [],
        size: 'normal',
        title: 'bar-code'
    },
    {
        name: 'menu-bar-code-scan',
        tags: [],
        size: 'normal',
        title: 'bar-code-scan'
    },
    {
        name: 'menu-bid',
        tags: [],
        size: 'normal',
        title: 'bid'
    },
    {
        name: 'menu-bitcoin-sign',
        tags: [],
        size: 'normal',
        title: 'bitcoin-sign'
    },
    {
        name: 'menu-bull-horn',
        tags: [],
        size: 'normal',
        title: 'bull-horn'
    },
    {
        name: 'menu-coin',
        tags: [],
        size: 'normal',
        title: 'coin'
    },
    {
        name: 'menu-credit-card',
        tags: [],
        size: 'normal',
        title: 'credit-card'
    },
    {
        name: 'menu-diamond',
        tags: [],
        size: 'normal',
        title: 'diamond'
    },
    {
        name: 'menu-dollar-sign',
        tags: [],
        size: 'normal',
        title: 'dollar-sign'
    },
    {
        name: 'menu-euro-sign',
        tags: [],
        size: 'normal',
        title: 'euro-sign'
    },
    {
        name: 'menu-hammer',
        tags: [],
        size: 'normal',
        title: 'hammer'
    },
    {
        name: 'menu-line-chart',
        tags: [],
        size: 'normal',
        title: 'line-chart'
    },
    {
        name: 'menu-lira-sign',
        tags: [],
        size: 'normal',
        title: 'lira-sign'
    },
    {
        name: 'menu-money',
        tags: [],
        size: 'normal',
        title: 'money'
    },

    {
        name: 'menu-newspaper',
        tags: [],
        size: 'normal',
        title: 'newspaper'
    },
    {
        name: 'menu-storefront',
        tags: [],
        size: 'normal',
        title: 'storefront'
    },
    {
        name: 'menu-money-stack',
        tags: [],
        size: 'normal',
        title: 'money-stack'
    },
    {
        name: 'menu-package',
        tags: [],
        size: 'normal',
        title: 'package'
    },
    {
        name: 'menu-piggy-bank',
        tags: [],
        size: 'normal',
        title: 'piggy-bank'
    },
    {
        name: 'menu-pound-sign',
        tags: [],
        size: 'normal',
        title: 'pound-sign'
    },
    {
        name: 'menu-price-tag',
        tags: [],
        size: 'normal',
        title: 'price-tag'
    },
    {
        name: 'menu-qr-code',
        tags: [],
        size: 'normal',
        title: 'qr-code'
    },
    {
        name: 'menu-qr-code-scan',
        tags: [],
        size: 'normal',
        title: 'qr-code-scan'
    },
    {
        name: 'menu-receipt',
        tags: [],
        size: 'normal',
        title: 'receipt'
    },
    {
        name: 'menu-rubel-sign',
        tags: [],
        size: 'normal',
        title: 'rubel-sign'
    },
    {
        name: 'menu-rupee-sign',
        tags: [],
        size: 'normal',
        title: 'rupee-sign'
    },
    {
        name: 'menu-sale-badge',
        tags: [],
        size: 'normal',
        title: 'sale-badge'
    },
    {
        name: 'menu-shopping-bag',
        tags: [],
        size: 'normal',
        title: 'shopping-bag'
    },
    {
        name: 'menu-shopping-bag-alt',
        tags: [],
        size: 'normal',
        title: 'shopping-bag-alt'
    },
    {
        name: 'menu-shopping-cart',
        tags: [],
        size: 'normal',
        title: 'shopping-cart'
    },
    {
        name: 'menu-won-sign',
        tags: [],
        size: 'normal',
        title: 'won-sign'
    },
    {
        name: 'menu-yen-sign',
        tags: [],
        size: 'normal',
        title: 'yen-sign'
    },
    {
        name: 'menu-add-item',
        tags: [],
        size: 'normal',
        title: 'add-item'
    },
    {
        name: 'menu-add-item-alt',
        tags: [],
        size: 'normal',
        title: 'add-item-alt'
    },
    {
        name: 'menu-add-note',
        tags: [],
        size: 'normal',
        title: 'add-note'
    },
    {
        name: 'menu-add-to-list',
        tags: [],
        size: 'normal',
        title: 'add-to-list'
    },
    {
        name: 'menu-at',
        tags: [],
        size: 'normal',
        title: 'at'
    },
    {
        name: 'menu-attach-document',
        tags: [],
        size: 'normal',
        title: 'attach-document'
    },
    {
        name: 'menu-bell',
        tags: [],
        size: 'normal',
        title: 'bell'
    },
    {
        name: 'menu-bell-alt',
        tags: [],
        size: 'normal',
        title: 'bell-alt'
    },
    {
        name: 'menu-bell-alt-ring',
        tags: [],
        size: 'normal',
        title: 'bell-alt-ring'
    },
    {
        name: 'menu-bell-slash',
        tags: [],
        size: 'normal',
        title: 'bell-slash'
    },
    {
        name: 'menu-bell-snoozy',
        tags: [],
        size: 'normal',
        title: 'bell-snoozy'
    },
    {
        name: 'menu-block',
        tags: [],
        size: 'normal',
        title: 'block'
    },
    {
        name: 'menu-book',
        tags: [],
        size: 'normal',
        title: 'book'
    },
    {
        name: 'menu-book-alt',
        tags: [],
        size: 'normal',
        title: 'book-alt'
    },
    {
        name: 'menu-bookmark',
        tags: [],
        size: 'normal',
        title: 'bookmark'
    },
    {
        name: 'menu-briefcase',
        tags: [],
        size: 'normal',
        title: 'briefcase'
    },
    {
        name: 'menu-calendar',
        tags: [],
        size: 'normal',
        title: 'calendar'
    },
    {
        name: 'menu-calendar-day',
        tags: [],
        size: 'normal',
        title: 'calendar-day'
    },
    {
        name: 'menu-calendar-month',
        tags: [],
        size: 'normal',
        title: 'calendar-month'
    },
    {
        name: 'menu-calendar-never',
        tags: [],
        size: 'normal',
        title: 'calendar-never'
    },
    {
        name: 'menu-calendar-week',
        tags: [],
        size: 'normal',
        title: 'calendar-week'
    },
    {
        name: 'menu-call-in',
        tags: [],
        size: 'normal',
        title: 'call-in'
    },
    {
        name: 'menu-call-out',
        tags: [],
        size: 'normal',
        title: 'call-out'
    },
    {
        name: 'menu-chat',
        tags: [],
        size: 'normal',
        title: 'chat'
    },
    {
        name: 'menu-checkmark',
        tags: [],
        size: 'normal',
        title: 'checkmark'
    },
    {
        name: 'menu-checkmark-circle',
        tags: [],
        size: 'normal',
        title: 'checkmark-circle'
    },
    {
        name: 'menu-checkmark-square',
        tags: [],
        size: 'normal',
        title: 'checkmark-square'
    },
    {
        name: 'menu-clock',
        tags: [],
        size: 'normal',
        title: 'clock'
    },
    {
        name: 'menu-close',
        tags: [],
        size: 'normal',
        title: 'close'
    },
    {
        name: 'menu-close-circle',
        tags: [],
        size: 'normal',
        title: 'close-circle'
    },
    {
        name: 'menu-close-square',
        tags: [],
        size: 'normal',
        title: 'close-square'
    },
    {
        name: 'menu-cog',
        tags: [],
        size: 'normal',
        title: 'cog'
    },
    {
        name: 'menu-comment',
        tags: [],
        size: 'normal',
        title: 'comment'
    },
    {
        name: 'menu-compass',
        tags: [],
        size: 'normal',
        title: 'compass'
    },
    {
        name: 'menu-delete',
        tags: [],
        size: 'normal',
        title: 'delete'
    },
    {
        name: 'menu-download',
        tags: [],
        size: 'normal',
        title: 'download'
    },
    {
        name: 'menu-earth',
        tags: [],
        size: 'normal',
        title: 'earth'
    },
    {
        name: 'menu-earth-alt',
        tags: [],
        size: 'normal',
        title: 'earth-alt'
    },
    {
        name: 'menu-exclamation-mark',
        tags: [],
        size: 'normal',
        title: 'exclamation-mark'
    },
    {
        name: 'menu-exclamation-triangle',
        tags: [],
        size: 'normal',
        title: 'exclamation-triangle'
    },
    {
        name: 'menu-export',
        tags: [],
        size: 'normal',
        title: 'export'
    },
    {
        name: 'menu-eye',
        tags: [],
        size: 'normal',
        title: 'eye'
    },
    {
        name: 'menu-eye-slash',
        tags: [],
        size: 'normal',
        title: 'eye-slash'
    },
    {
        name: 'menu-face-id',
        tags: [],
        size: 'normal',
        title: 'face-id'
    },
    {
        name: 'menu-flag',
        tags: [],
        size: 'normal',
        title: 'flag'
    },
    {
        name: 'menu-grid',
        tags: [],
        size: 'normal',
        title: 'grid'
    },
    {
        name: 'menu-hamburger-menu',
        tags: [],
        size: 'normal',
        title: 'hamburger-menu'
    },
    {
        name: 'menu-heart',
        tags: [],
        size: 'normal',
        title: 'heart'
    },
    {
        name: 'menu-history',
        tags: [],
        size: 'normal',
        title: 'history'
    },
    {
        name: 'menu-import',
        tags: [],
        size: 'normal',
        title: 'import'
    },
    {
        name: 'menu-info-circle',
        tags: [],
        size: 'normal',
        title: 'info-circle'
    },
    {
        name: 'menu-lifebelt',
        tags: [],
        size: 'normal',
        title: 'lifebelt'
    },
    {
        name: 'menu-link',
        tags: [],
        size: 'normal',
        title: 'link'
    },
    {
        name: 'menu-lock',
        tags: [],
        size: 'normal',
        title: 'lock'
    },
    {
        name: 'menu-lock-alt',
        tags: [],
        size: 'normal',
        title: 'lock-alt'
    },
    {
        name: 'menu-mail',
        tags: [],
        size: 'normal',
        title: 'mail'
    },
    {
        name: 'menu-map-market',
        tags: [],
        size: 'normal',
        title: 'map-market'
    },
    {
        name: 'menu-minus',
        tags: [],
        size: 'normal',
        title: 'minus'
    },
    {
        name: 'menu-minus-circle',
        tags: [],
        size: 'normal',
        title: 'minus-circle'
    },
    {
        name: 'menu-minus-square',
        tags: [],
        size: 'normal',
        title: 'minus-square'
    },
    {
        name: 'menu-more-h',
        tags: [],
        size: 'normal',
        title: 'more-h'
    },
    {
        name: 'menu-more-v',
        tags: [],
        size: 'normal',
        title: 'more-v'
    },
    {
        name: 'menu-my-location',
        tags: [],
        size: 'normal',
        title: 'my-location'
    },
    {
        name: 'menu-paperclip',
        tags: [],
        size: 'normal',
        title: 'paperclip'
    },
    {
        name: 'menu-password',
        tags: [],
        size: 'normal',
        title: 'password'
    },
    {
        name: 'menu-phone',
        tags: [],
        size: 'normal',
        title: 'phone'
    },
    {
        name: 'menu-pin',
        tags: [],
        size: 'normal',
        title: 'pin'
    },
    {
        name: 'menu-plus',
        tags: [],
        size: 'normal',
        title: 'plus'
    },
    {
        name: 'menu-plus-circle',
        tags: [],
        size: 'normal',
        title: 'plus-circle'
    },
    {
        name: 'menu-plus-square',
        tags: [],
        size: 'normal',
        title: 'plus-square'
    },
    {
        name: 'menu-search',
        tags: [],
        size: 'normal',
        title: 'search'
    },
    {
        name: 'menu-send',
        tags: [],
        size: 'normal',
        title: 'send'
    },
    {
        name: 'menu-share',
        tags: [],
        size: 'normal',
        title: 'share'
    },
    {
        name: 'menu-shortcut',
        tags: [],
        size: 'normal',
        title: 'shortcut'
    },
    {
        name: 'menu-sign-in',
        tags: [],
        size: 'normal',
        title: 'sign-in'
    },
    {
        name: 'menu-sign-out',
        tags: [],
        size: 'normal',
        title: 'sign-out'
    },
    {
        name: 'menu-task',
        tags: [],
        size: 'normal',
        title: 'task'
    },
    {
        name: 'menu-thumbs-down',
        tags: [],
        size: 'normal',
        title: 'thumbs-down'
    },
    {
        name: 'menu-thumbs-up',
        tags: [],
        size: 'normal',
        title: 'thumbs-up'
    },
    {
        name: 'menu-trash',
        tags: [],
        size: 'normal',
        title: 'trash'
    },
    {
        name: 'menu-unlink',
        tags: [],
        size: 'normal',
        title: 'unlink'
    },
    {
        name: 'menu-upload',
        tags: [],
        size: 'normal',
        title: 'upload'
    },
    {
        name: 'menu-user',
        tags: [],
        size: 'normal',
        title: 'user'
    },
    {
        name: 'menu-user-circle',
        tags: [],
        size: 'normal',
        title: 'user-circle'
    },
    {
        name: 'menu-user-delete',
        tags: [],
        size: 'normal',
        title: 'user-delete'
    },
    {
        name: 'menu-user-follow',
        tags: [],
        size: 'normal',
        title: 'user-follow'
    },
    {
        name: 'menu-user-minus',
        tags: [],
        size: 'normal',
        title: 'user-minus'
    },
    {
        name: 'menu-user-plus',
        tags: [],
        size: 'normal',
        title: 'user-plus'
    },
    {
        name: 'menu-archive',
        tags: [],
        size: 'normal',
        title: 'archive'
    },
    {
        name: 'menu-document',
        tags: [],
        size: 'normal',
        title: 'document'
    },
    {
        name: 'menu-folder',
        tags: [],
        size: 'normal',
        title: 'folder'
    },
    {
        name: 'menu-folder-delete',
        tags: [],
        size: 'normal',
        title: 'folder-delete'
    },
    {
        name: 'menu-folder-minus',
        tags: [],
        size: 'normal',
        title: 'folder-minus'
    },
    {
        name: 'menu-folder-open',
        tags: [],
        size: 'normal',
        title: 'folder-open'
    },
    {
        name: 'menu-folder-plus',
        tags: [],
        size: 'normal',
        title: 'folder-plus'
    },
    {
        name: 'menu-note',
        tags: [],
        size: 'normal',
        title: 'note'
    },
    {
        name: 'menu-notebook',
        tags: [],
        size: 'normal',
        title: 'notebook'
    },
    {
        name: 'menu-script',
        tags: [],
        size: 'normal',
        title: 'script'
    },
    {
        name: 'menu-sticker',
        tags: [],
        size: 'normal',
        title: 'sticker'
    },
    {
        name: 'menu-sticky-notes',
        tags: [],
        size: 'normal',
        title: 'sticky-notes'
    },
    {
        name: 'menu-tray',
        tags: [],
        size: 'normal',
        title: 'tray'
    },
    {
        name: 'menu-tray-delete',
        tags: [],
        size: 'normal',
        title: 'tray-delete'
    },
    {
        name: 'menu-tray-empty',
        tags: [],
        size: 'normal',
        title: 'tray-empty'
    },
    {
        name: 'menu-tray-export',
        tags: [],
        size: 'normal',
        title: 'tray-export'
    },
    {
        name: 'menu-tray-import',
        tags: [],
        size: 'normal',
        title: 'tray-import'
    },
    {
        name: 'menu-tray-minus',
        tags: [],
        size: 'normal',
        title: 'tray-minus'
    },
    {
        name: 'menu-tray-plus',
        tags: [],
        size: 'normal',
        title: 'tray-plus'
    },
    {
        name: 'menu-tray-stack',
        tags: [],
        size: 'normal',
        title: 'tray-stack'
    },
    {
        name: 'menu-artboard',
        tags: [],
        size: 'normal',
        title: 'artboard'
    },
    {
        name: 'menu-brush',
        tags: [],
        size: 'normal',
        title: 'brush'
    },
    {
        name: 'menu-clipboard',
        tags: [],
        size: 'normal',
        title: 'clipboard'
    },
    {
        name: 'menu-copy',
        tags: [],
        size: 'normal',
        title: 'copy'
    },
    {
        name: 'menu-copy-alt',
        tags: [],
        size: 'normal',
        title: 'copy-alt'
    },
    {
        name: 'menu-crop',
        tags: [],
        size: 'normal',
        title: 'crop'
    },
    {
        name: 'menu-cut',
        tags: [],
        size: 'normal',
        title: 'cut'
    },
    {
        name: 'menu-cut-alt',
        tags: [],
        size: 'normal',
        title: 'cut-alt'
    },
    {
        name: 'menu-drafting-compass',
        tags: [],
        size: 'normal',
        title: 'drafting-compass'
    },
    {
        name: 'menu-duplicate',
        tags: [],
        size: 'normal',
        title: 'duplicate'
    },
    {
        name: 'menu-duplicate-alt',
        tags: [],
        size: 'normal',
        title: 'duplicate-alt'
    },
    {
        name: 'menu-eraser',
        tags: [],
        size: 'normal',
        title: 'eraser'
    },
    {
        name: 'menu-eye-dropper',
        tags: [],
        size: 'normal',
        title: 'eye-dropper'
    },
    {
        name: 'menu-group',
        tags: [],
        size: 'normal',
        title: 'group'
    },
    {
        name: 'menu-layer-stack',
        tags: [],
        size: 'normal',
        title: 'layer-stack'
    },
    {
        name: 'menu-magic-wand',
        tags: [],
        size: 'normal',
        title: 'magic-wand'
    },
    {
        name: 'menu-marker',
        tags: [],
        size: 'normal',
        title: 'marker'
    },
    {
        name: 'menu-paint-bucket',
        tags: [],
        size: 'normal',
        title: 'paint-bucket'
    },
    {
        name: 'menu-paint-roller',
        tags: [],
        size: 'normal',
        title: 'paint-roller'
    },
    {
        name: 'menu-palette',
        tags: [],
        size: 'normal',
        title: 'palette'
    },
    {
        name: 'menu-paste',
        tags: [],
        size: 'normal',
        title: 'paste'
    },
    {
        name: 'menu-paste-alt',
        tags: [],
        size: 'normal',
        title: 'paste-alt'
    },
    {
        name: 'menu-pen',
        tags: [],
        size: 'normal',
        title: 'pen'
    },
    {
        name: 'menu-pen-circle',
        tags: [],
        size: 'normal',
        title: 'pen-circle'
    },
    {
        name: 'menu-pencil',
        tags: [],
        size: 'normal',
        title: 'pencil'
    },
    {
        name: 'menu-pencil-circle',
        tags: [],
        size: 'normal',
        title: 'pencil-circle'
    },
    {
        name: 'menu-ruler-combined',
        tags: [],
        size: 'normal',
        title: 'ruler-combined'
    },
    {
        name: 'menu-ruler-h',
        tags: [],
        size: 'normal',
        title: 'ruler-h'
    },
    {
        name: 'menu-ruler-v',
        tags: [],
        size: 'normal',
        title: 'ruler-v'
    },
    {
        name: 'menu-stamp',
        tags: [],
        size: 'normal',
        title: 'stamp'
    },
    {
        name: 'menu-table',
        tags: [],
        size: 'normal',
        title: 'table'
    },
    {
        name: 'menu-activity',
        tags: [],
        size: 'normal',
        title: 'activity'
    },
    {
        name: 'menu-android',
        tags: [],
        size: 'normal',
        title: 'android'
    },
    {
        name: 'menu-apple',
        tags: [],
        size: 'normal',
        title: 'apple'
    },
    {
        name: 'menu-bolt',
        tags: [],
        size: 'normal',
        title: 'bolt'
    },
    {
        name: 'menu-cloud-download',
        tags: [],
        size: 'normal',
        title: 'cloud-download'
    },
    {
        name: 'menu-cloud-minus',
        tags: [],
        size: 'normal',
        title: 'cloud-minus'
    },
    {
        name: 'menu-cloud-plus',
        tags: [],
        size: 'normal',
        title: 'cloud-plus'
    },
    {
        name: 'menu-cloud-upload',
        tags: [],
        size: 'normal',
        title: 'cloud-upload'
    },
    {
        name: 'menu-code',
        tags: [],
        size: 'normal',
        title: 'code'
    },
    {
        name: 'menu-command',
        tags: [],
        size: 'normal',
        title: 'command'
    },
    {
        name: 'menu-database',
        tags: [],
        size: 'normal',
        title: 'database'
    },
    {
        name: 'menu-deploy',
        tags: [],
        size: 'normal',
        title: 'deploy'
    },
    {
        name: 'menu-git-branch',
        tags: [],
        size: 'normal',
        title: 'git-branch'
    },
    {
        name: 'menu-git-commit',
        tags: [],
        size: 'normal',
        title: 'git-commit'
    },
    {
        name: 'menu-git-fork',
        tags: [],
        size: 'normal',
        title: 'git-fork'
    },
    {
        name: 'menu-git-merge',
        tags: [],
        size: 'normal',
        title: 'git-merge'
    },
    {
        name: 'menu-git-pull',
        tags: [],
        size: 'normal',
        title: 'git-pull'
    },
    {
        name: 'menu-ios',
        tags: [],
        size: 'normal',
        title: 'ios'
    },
    {
        name: 'menu-lan',
        tags: [],
        size: 'normal',
        title: 'lan'
    },
    {
        name: 'menu-lan-connection',
        tags: [],
        size: 'normal',
        title: 'lan-connection'
    },
    {
        name: 'menu-lan-error',
        tags: [],
        size: 'normal',
        title: 'lan-error'
    },
    {
        name: 'menu-osx',
        tags: [],
        size: 'normal',
        title: 'osx'
    },
    {
        name: 'menu-repository',
        tags: [],
        size: 'normal',
        title: 'repository'
    },
    {
        name: 'menu-web',
        tags: [],
        size: 'normal',
        title: 'web'
    },
    {
        name: 'menu-window',
        tags: [],
        size: 'normal',
        title: 'window'
    },
    {
        name: 'menu-window-delete',
        tags: [],
        size: 'normal',
        title: 'window-delete'
    },
    {
        name: 'menu-window-minus',
        tags: [],
        size: 'normal',
        title: 'window-minus'
    },
    {
        name: 'menu-window-plus',
        tags: [],
        size: 'normal',
        title: 'window-plus'
    },
    {
        name: 'menu-airpods',
        tags: [],
        size: 'normal',
        title: 'airpods'
    },

    {
        name: 'menu-airplay',
        tags: [],
        size: 'normal',
        title: 'airplay'
    },
    {
        name: 'menu-broadcast',
        tags: [],
        size: 'normal',
        title: 'broadcast'
    },
    {
        name: 'menu-camera',
        tags: [],
        size: 'normal',
        title: 'camera'
    },
    {
        name: 'menu-camera-alt',
        tags: [],
        size: 'normal',
        title: 'camera-alt'
    },
    {
        name: 'menu-camera-alt-2',
        tags: [],
        size: 'normal',
        title: 'camera-alt-2'
    },
    {
        name: 'menu-cast',
        tags: [],
        size: 'normal',
        title: 'cast'
    },
    {
        name: 'menu-collapse-wide',
        tags: [],
        size: 'normal',
        title: 'collapse-wide'
    },
    {
        name: 'menu-disk',
        tags: [],
        size: 'normal',
        title: 'disk'
    },
    {
        name: 'menu-expand-wide',
        tags: [],
        size: 'normal',
        title: 'expand-wide'
    },
    {
        name: 'menu-film',
        tags: [],
        size: 'normal',
        title: 'film'
    },
    {
        name: 'menu-film-alt',
        tags: [],
        size: 'normal',
        title: 'film-alt'
    },
    {
        name: 'menu-film-play',
        tags: [],
        size: 'normal',
        title: 'film-play'
    },
    {
        name: 'menu-image',
        tags: [],
        size: 'normal',
        title: 'image'
    },
    {
        name: 'menu-image-circle',
        tags: [],
        size: 'normal',
        title: 'image-circle'
    },
    {
        name: 'menu-image-gallery',
        tags: [],
        size: 'normal',
        title: 'image-circle-gallery'
    },
    {
        name: 'menu-image-wide',
        tags: [],
        size: 'normal',
        title: 'image-circle-wide'
    },
    {
        name: 'menu-microphone',
        tags: [],
        size: 'normal',
        title: 'microphone'
    },
    {
        name: 'menu-microphone-mute',
        tags: [],
        size: 'normal',
        title: 'microphone-mute'
    },
    {
        name: 'menu-next',
        tags: [],
        size: 'normal',
        title: 'next'
    },
    {
        name: 'menu-next-alt',
        tags: [],
        size: 'normal',
        title: 'next-alt'
    },
    {
        name: 'menu-panorama-h',
        tags: [],
        size: 'normal',
        title: 'panorama-h'
    },
    {
        name: 'menu-pause',
        tags: [],
        size: 'normal',
        title: 'pause'
    },
    {
        name: 'menu-pause-alt',
        tags: [],
        size: 'normal',
        title: 'pause-alt'
    },
    {
        name: 'menu-play',
        tags: [],
        size: 'normal',
        title: 'play'
    },
    {
        name: 'menu-play-alt',
        tags: [],
        size: 'normal',
        title: 'play-alt'
    },
    {
        name: 'menu-previous',
        tags: [],
        size: 'normal',
        title: 'previous'
    },
    {
        name: 'menu-shuffle',
        tags: [],
        size: 'normal',
        title: 'shuffle'
    },
    {
        name: 'menu-video',
        tags: [],
        size: 'normal',
        title: 'video'
    },
    {
        name: 'menu-video-alt',
        tags: [],
        size: 'normal',
        title: 'video-alt'
    },
    {
        name: 'menu-video-camera',
        tags: [],
        size: 'normal',
        title: 'video-camera'
    },
    {
        name: 'menu-volume-low',
        tags: [],
        size: 'normal',
        title: 'volume-low'
    },
    {
        name: 'menu-volume-max',
        tags: [],
        size: 'normal',
        title: 'volume-max'
    },
    {
        name: 'menu-volume-mid',
        tags: [],
        size: 'normal',
        title: 'volume-mid'
    },
    {
        name: 'menu-volume-min',
        tags: [],
        size: 'normal',
        title: 'volume-min'
    },
    {
        name: 'menu-wide-angle',
        tags: [],
        size: 'normal',
        title: 'wide-angle'
    },

    {
        name: 'menu-airpods-alt',
        tags: [],
        size: 'normal',
        title: 'airpods-alt'
    },
    {
        name: 'menu-apple-watch',
        tags: [],
        size: 'normal',
        title: 'apple-watch'
    },
    {
        name: 'menu-apple-watch-smile',
        tags: [],
        size: 'normal',
        title: 'apple-watch-smile'
    },
    {
        name: 'menu-apple-watch-time',
        tags: [],
        size: 'normal',
        title: 'apple-watch-time'
    },
    {
        name: 'menu-cable-hdmi',
        tags: [],
        size: 'normal',
        title: 'cable-hdmi'
    },
    {
        name: 'menu-cable-jack',
        tags: [],
        size: 'normal',
        title: 'cable-jack'
    },
    {
        name: 'menu-cable-lan',
        tags: [],
        size: 'normal',
        title: 'cable-lan'
    },
    {
        name: 'menu-cable-lightning',
        tags: [],
        size: 'normal',
        title: 'cable-lightning'
    },
    {
        name: 'menu-cable-magsafe',
        tags: [],
        size: 'normal',
        title: 'cable-magsafe'
    },
    {
        name: 'menu-cable-usb',
        tags: [],
        size: 'normal',
        title: 'cable-usb'
    },
    {
        name: 'menu-carboard-vr',
        tags: [],
        size: 'normal',
        title: 'carboard-vr'
    },
    {
        name: 'menu-controller',
        tags: [],
        size: 'normal',
        title: 'controller'
    },
    {
        name: 'menu-controller-alt',
        tags: [],
        size: 'normal',
        title: 'controller-alt'
    },
    {
        name: 'menu-desktop',
        tags: [],
        size: 'normal',
        title: 'desktop'
    },
    {
        name: 'menu-devices',
        tags: [],
        size: 'normal',
        title: 'devices'
    },
    {
        name: 'menu-floopy',
        tags: [],
        size: 'normal',
        title: 'floopy'
    },
    {
        name: 'menu-gameboy',
        tags: [],
        size: 'normal',
        title: 'gameboy'
    },
    {
        name: 'menu-hard-drive',
        tags: [],
        size: 'normal',
        title: 'hard-drive'
    },
    {
        name: 'menu-headphone',
        tags: [],
        size: 'normal',
        title: 'headphone'
    },
    {
        name: 'menu-imac',
        tags: [],
        size: 'normal',
        title: 'imac'
    },
    {
        name: 'menu-ipad',
        tags: [],
        size: 'normal',
        title: 'ipad'
    },
    {
        name: 'menu-ipad-h',
        tags: [],
        size: 'normal',
        title: 'ipad-h'
    },
    {
        name: 'menu-iphone',
        tags: [],
        size: 'normal',
        title: 'iphone'
    },
    {
        name: 'menu-iphone-h',
        tags: [],
        size: 'normal',
        title: 'iphone-h'
    },
    {
        name: 'menu-iphone-x',
        tags: [],
        size: 'normal',
        title: 'iphone-x'
    },
    {
        name: 'menu-iphone-x-h',
        tags: [],
        size: 'normal',
        title: 'iphone-x-h'
    },
    {
        name: 'menu-keyboard',
        tags: [],
        size: 'normal',
        title: 'keyboard'
    },
    {
        name: 'menu-laptop',
        tags: [],
        size: 'normal',
        title: 'laptop'
    },
    {
        name: 'menu-mac-pro',
        tags: [],
        size: 'normal',
        title: 'mac-pro'
    },
    {
        name: 'menu-memory-card',
        tags: [],
        size: 'normal',
        title: 'memory-card'
    },
    {
        name: 'menu-mouse',
        tags: [],
        size: 'normal',
        title: 'mouse'
    },
    {
        name: 'menu-phone-android',
        tags: [],
        size: 'normal',
        title: 'phone-android'
    },
    {
        name: 'menu-phone-android-h',
        tags: [],
        size: 'normal',
        title: 'phone-android-h'
    },
    {
        name: 'menu-phone-holding',
        tags: [],
        size: 'normal',
        title: 'phone-holding'
    },
    {
        name: 'menu-phone-holding-double',
        tags: [],
        size: 'normal',
        title: 'phone-holding-double'
    },
    {
        name: 'menu-plug',
        tags: [],
        size: 'normal',
        title: 'plug'
    },
    {
        name: 'menu-printer',
        tags: [],
        size: 'normal',
        title: 'printer'
    },
    {
        name: 'menu-server-stack',
        tags: [],
        size: 'normal',
        title: 'server-stack'
    },
    {
        name: 'menu-smart-glasses',
        tags: [],
        size: 'normal',
        title: 'smart-glasses'
    },
    {
        name: 'menu-smart-tv',
        tags: [],
        size: 'normal',
        title: 'smart-tv'
    },
    {
        name: 'menu-smart-watch',
        tags: [],
        size: 'normal',
        title: 'smart-watch'
    },
    {
        name: 'menu-smart-watch-time',
        tags: [],
        size: 'normal',
        title: 'smart-watch-time'
    },
    {
        name: 'menu-tablet',
        tags: [],
        size: 'normal',
        title: 'tablet'
    },
    {
        name: 'menu-tablet-h',
        tags: [],
        size: 'normal',
        title: 'tablet-h'
    },
    {
        name: 'menu-terminal',
        tags: [],
        size: 'normal',
        title: 'terminal'
    },
    {
        name: 'menu-windows',
        tags: [],
        size: 'normal',
        title: 'windows'
    },
    {
        name: 'menu-virtual-reality',
        tags: [],
        size: 'normal',
        title: 'virtual-reality'
    },

    {
        name: 'menu-binance',
        tags: [],
        size: 'normal',
        title: 'binance'
    },
    {
        name: 'menu-ethereum',
        tags: [],
        size: 'normal',
        title: 'ethereum'
    },
    {
        name: 'menu-check-square-offset',
        tags: [],
        size: 'normal',
        title: 'check-square-offset'
    },
    {
        name: 'menu-marketing-plan',
        tags: [],
        size: 'normal',
        title: 'marketing-plan'
    },
    {
        name: 'menu-paper-plan-tilt',
        tags: [],
        size: 'normal',
        title: 'paper-plan-tilt'
    },
    {
        name: 'menu-shield-check',
        tags: [],
        size: 'normal',
        title: 'shield-check'
    },
    {
        name: 'menu-tool',
        tags: [],
        size: 'normal',
        title: 'tool'
    },
    {
        name: 'menu-trophy',
        tags: [],
        size: 'normal',
        title: 'trophy'
    },

    {
        name: 'menu-voice-assistant',
        tags: [],
        size: 'normal',
        title: 'voice-assistant'
    },
    {
        name: 'menu-education',
        tags: [],
        size: 'normal',
        title: 'education'
    }
];
